// src/components/App/index.js
import React, { Component } from 'react';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import FlatButton from 'material-ui/FlatButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import CompanyRow from '../FrontPage/CompanyRow';
import AutoComplete from 'material-ui/AutoComplete';
import BaseService from '../../service/baseservice';
import {Toolbar, ToolbarGroup} from 'material-ui/Toolbar';
import CompanyEditDialog from '../FrontPage/CompanyEditDialog';
import CompanyActionsToolbar from './CompanyActionsToolbar';
import CompanyService from '../../service/companies';
import Checkbox from 'material-ui/Checkbox';

var Auth = require('../../service/auth'); // todo: no

export default class CompanyList extends Component {
  emptyCompany() {
    return {
          marketingName: "",
          officialName:"",
          streetAddress:"",
          companyContacts: [],
          decisionHistory: []
      };
  }

  state = {
    dialogOpen: false,
    selectedCompany: this.emptyCompany(),
    selectedTargetSeller: null
  };

  props = {
    selectedCompanies: [],
    companies: [],
    onClose: () => {}
  }

  onSelectedRow = (selected) => {
    var selectedCompanies = [];
      if (selected == "all") {
        for (var i = 0; i < this.props.companies.length; i++) {
          selectedCompanies.push(i);
        }
      } else if (selected == "none") {
        selectedCompanies = [];
      } else {
        selectedCompanies = selected;
    }

    this.props.onSelectedCompanies(selectedCompanies);
  }

  loadMoreCompanies() {
    var from = this.state.filters.from;
    var to = this.state.filters.to + 50;
    this.setState({filters: {'from': from, 'to': to}}, () => this.fetchCompanies());
  }

  onCompanySelected(selected) {
    let newState = {
      dialogOpen:true,
      companyIndex: selected,
      selectedCompany: this.props.companies[selected]
    };

    this.setState(newState);
  }

  onTargetSellerSelected = (selectedSeller) => {
    this.setState({selectedTargetSeller: selectedSeller});
  }

  onAssignSeller = () => {
    var companyIds = this.props.selectedCompanies.map(companyIdx => this.props.companies[companyIdx]._id);
    CompanyService.assignSellerToCompanies(this.state.selectedTargetSeller, companyIds).then(() => {
      this.setState({selectedTargetSeller: null, selectedCompanies: []});
      this.props.refreshList();
    });
  }

  handleClose() {
    this.setState({dialogOpen: false});
    this.props.refreshList()
  }

  renderRow(company) {
    var selectedIndex = this.props.companies.indexOf(company);
    var selected = Auth.userData.isAdmin && this.props.selectedCompanies.includes(selectedIndex);
    var segment = '';

    if (company.contractValue > 14) {
      segment = 'A - ';
    } else if (company.contractValue > 0) {
      segment = 'B - ';
    }

    var secondaryInfo = '';
    var sellerName = '';
    var assignedDate = '';

    if (company.seller && company.seller != null) {
      sellerName = company.seller.fullName;
    }

    if (company.assignedToSeller && company.assignedToSeller != null) {
      var userAssignedDate = new Date(company.assignedToSeller);
      assignedDate = userAssignedDate.getDate() + "." + (userAssignedDate.getMonth()+1) + "." + userAssignedDate.getFullYear();
    }

    if (Auth.userData.isAdmin) {
      secondaryInfo = <span>{sellerName} <br/> {assignedDate}</span>;
    } else {
      secondaryInfo = assignedDate;
    }

    let lastDecisionDiv = null;
    if (company.decisionHistory.length > 0) {
      var lastDecision = company.decisionHistory
              .filter(a => (a.type != undefined))
              .sort((a,b) =>  new Date(b.date) - new Date(a.date))[0];

      if (lastDecision) {
        var date = new Date(lastDecision.date);

        lastDecisionDiv = <div>
          <span>{lastDecision.type.name} {date.getDate() + "." + (date.getMonth()+1) + "." + date.getFullYear()} <br/>
          {lastDecision.seller ? lastDecision.seller.fullName : ''}</span>
        </div>;
      } else {
        lastDecisionDiv = <div>Ei päätöksiä.</div>
      }
    }  else {
      lastDecisionDiv = <div>Ei päätöksiä.</div>
    }

    let sellerInProgressRow = null;
    if (!Auth.userData.isAdmin) {
      sellerInProgressRow = <TableRowColumn style={{width:"30px"}}><Checkbox disabled={company.isInProgressForSellerInProgress} checked={company.isInProgressForSeller} onCheck={(component) => this.onCompanyProgressToggled(selectedIndex, component)}/></TableRowColumn>;
    }

    const notPublishedStyle = { backgroundColor: 'yellow', opacity: '0.5' }
    
    const style = company.isPublished ? {} : notPublishedStyle

    return <TableRow key={company._id} selected={selected} selectable={Auth.userData.isAdmin} style={style}>
      <TableRowColumn style={{whiteSpace:'normal'}}>
        {company.marketingName ? company.marketingName : company.officialName}<br/>
        <span style={{fontSize:"10px", color:"grey"}}>{company.marketingName ? company.officialName : ''}</span>
      </TableRowColumn>
      <TableRowColumn style={{width: "90px", whiteSpace: 'normal'}}>
        {segment}
        {(company.contractValue && company.contractValue > 0) ? company.contractValue + " €" : "Ei ostoa"}<br/>
        {secondaryInfo}
      </TableRowColumn>
      <TableRowColumn style={{width: "90px", whiteSpace: 'normal'}}>
        {lastDecisionDiv}
      </TableRowColumn>
      <TableRowColumn style={{whiteSpace:'normal'}}>
        {company.industry ? company.industry.name : '-'}<br/>
        <span style={{fontSize:"10px", color:"grey"}}>{company.mainCategory ? company.mainCategory.name : ''}</span>
      </TableRowColumn>
      <TableRowColumn style={{whiteSpace:'normal', width:'120px'}}>
        {company.city ? company.city.name : ''}<br/>
        {company.municipality}
      </TableRowColumn>
      <TableRowColumn style={{whiteSpace:'normal', width: '180px'}}>
        {company.phoneNumber}<br/>
        {company.emailAddress}
      </TableRowColumn>
      {sellerInProgressRow}
      <TableRowColumn style={{whiteSpace:'normal', width:'90px'}}>
        <FlatButton label="Muokkaa" onTouchTap={() => this.onCompanySelected(selectedIndex)}/>
      </TableRowColumn>
    </TableRow>;
  }

  renderTable(rows) {
    let sellerInProgressRow = null;
    if (!Auth.userData.isAdmin) {
      sellerInProgressRow = <TableHeaderColumn style={{width:"30px"}}>Kesken?</TableHeaderColumn>;
    }

    return <Table
      multiSelectable={this.props.multiSelectable}
      onRowSelection={(rows) => this.onSelectedRow(rows)}>
      <TableHeader
        displaySelectAll={this.props.multiSelectable}
        enableSelectAll={this.props.multiSelectable}>
        <TableRow>
          <TableHeaderColumn>Nimi</TableHeaderColumn>
          <TableHeaderColumn style={{width:"90px"}}>Segmentti & myyjä</TableHeaderColumn>
          <TableHeaderColumn style={{whiteSpace:'normal', width:"90px"}}>Edellinen päätös</TableHeaderColumn>
          <TableHeaderColumn style={{whiteSpace:'normal'}}>Toimiala</TableHeaderColumn>
          <TableHeaderColumn style={{whiteSpace:'normal', width:'120px'}}>Paikkakunta</TableHeaderColumn>
          <TableHeaderColumn style={{whiteSpace:'normal', width: '180px'}}>Yhteystiedot</TableHeaderColumn>
          {sellerInProgressRow}
          {this.renderTotalCount()}
        </TableRow>
      </TableHeader>
      <TableBody displayRowCheckbox={this.props.multiSelectable}
        stripedRows={false}
        deselectOnClickaway={false}>
        {rows}
      </TableBody>
    </Table>;
  }

  renderTotalCount() {
    if (this.props.total) {
      return <TableHeaderColumn style={{whiteSpace:'normal', width:'90px'}}><b style={{color: 'black'}}>{this.props.total} osumaa</b></TableHeaderColumn>
    } else {
      return <TableHeaderColumn style={{whiteSpace:'normal', width:'90px'}}/>
    }
  }

  deselectAllCompanies() {
    this.setState({selectedCompanies: []});
  }

  render() {
    var rows = this.props.companies.map(company => {
      return this.renderRow(company);
    });
    console.log(this.props.total)
    var left = this.props.total - this.props.companies.length;
    var more = Math.min(left, 50);
    var table = this.props.companies.length > 0 ? this.renderTable(rows) : '';

    const actionsToolbar = this.props.selectedCompanies.length > 0 ?
        <CompanyActionsToolbar
          selectedCompanies={this.props.selectedCompanies}
          selectedSeller={this.state.selectedTargetSeller}
          onTargetSellerSelected={(seller) => this.onTargetSellerSelected(seller)}
          onAssignSeller={(seller) => this.onAssignSeller(seller)}/> : null;

    return (
      <div>
        <div className="main-container">
          {table}
          {actionsToolbar}
        </div>

        <CompanyEditDialog
          enabled={this.state.dialogOpen}
          handleClose={() => this.handleClose()}
          company={this.state.selectedCompany} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/CompanyList.js